module.exports = __webpack_public_path__ + "img/hero.175fb3b9.png";